import PageRoute from "../../constant/pageRouteDictionary.json";
import ProductView from "../../pages/ProductView";

const ProjectFileView = ({ rootFolderId }) => (
  <ProductView
    pseudoRootFolderId={rootFolderId}
    viewPathName={PageRoute.FILE_VIEW}
  />
);

export default ProjectFileView;
